
<div class="row">
    <div class="col-12">
        <ngx-loading [show]="loadingIndicator"></ngx-loading>
    </div> 

    <div class="col-12" *ngIf="!loadingIndicator">
        <div widget class="card border-0 box-shadow">
            <div class="card-header border-0 " style="font-size:11pt"> Control No: <span class="text-primary font-weight-bold" style="font-size:11pt">{{run?.control_no}}</span> &nbsp;
                <button class="btn btn-sm btn-outline-secondary" (click)="goToRunDetails()"><i class="fa fa-md fa-angle-double-left" ngbTooltip="Go to Manifest details"></i></button></div>
            <div class="card-body pt-0 widget-body"> 
                <span style="color:gray"> Job Type: </span><strong> {{run?.run_type}}</strong> &nbsp;&nbsp;&nbsp;
                <span style="color:gray"> Service Category Type: </span><strong> {{run?.service_type}}</strong> &nbsp;&nbsp;&nbsp;
                <span style="color:gray"> Route: </span><strong> {{run?.run_route}} - {{run?.run_route_klms}}</strong> &nbsp;&nbsp;&nbsp;
                <span style="color:gray"> Schedule: </span><strong> {{run?.departure_date  | date:'EE, d MMM y'}} - {{run?.arrival_date  | date:'EE, d MMM y'}}</strong> &nbsp;&nbsp;&nbsp;<br/>
                <span style="color:gray"> Driver/s: </span><strong *ngFor="let driver of run_drivers; let i=index">{{i>0?'/ ':''}} {{driver?.first_name}} {{driver?.last_name}} </strong>&nbsp;&nbsp;&nbsp;
                <span style="color:gray"> Truck: </span><strong *ngFor="let equipment of run_equipments"><span *ngIf="equipment.is_truck == 1">[{{equipment?.rego}}] </span></strong>&nbsp;&nbsp;&nbsp;
                <span style="color:gray"> Trailer/s: </span><strong *ngFor="let equipment of run_equipments;"><span *ngIf="equipment.is_truck == 0;">({{equipment?.rego}}) </span></strong>&nbsp;&nbsp;&nbsp;
                <span style="color:gray"> Dispatched Date: </span><strong> {{run?.created_at  | date:'EE, d MMM y'}}</strong> &nbsp;&nbsp;&nbsp;
                <span style="color:gray"> Dispatched By: </span><strong> {{run?.created_by_name}}</strong> &nbsp;&nbsp;&nbsp;
            </div>
        </div><br/>
    
        <div widget class="card border-0 box-shadow">
            <div class="card-header transparent border-0 text-muted"></div>
            <div class="card-body pt-0 widget-body"> 
                <div class="row pl-3 pr-3 event-container">
                    <!-- List of run events -->  
                    <div class="col-md-4 bg-white p-1">
                        <div class="col-md-12" style="background-color:maroon"><h5 style="color:white"> Manifest Actual Events </h5></div>
                        <div class="event-list" perfectScrollbar>
                            <div *ngFor="let r_event of run_events"  class="event-list-item pb-2 pt-2 pl-1 pr-2 transititon" (click)="viewEventDetails(r_event)" [ngClass]="{'selected': r_event.selected}">
                                <div class="media">
                                    <div class="media-body overflow-hidden">
                                        <div class="d-flex justify-content-between">
                                            <strong class="text-truncate event-name"
                                                [ngClass]="{'text-success': r_event.run_action_id == 1,
                                                    'text-info': r_event.run_action_id == 2,
                                                    'text-danger': r_event.run_action_id == 3 || r_event.run_action_id == 13,
                                                    'text-secondary': r_event.run_action_id == 4,
                                                    'text-warning': r_event.run_action_id == 14 || r_event.run_action_id == 15,
                                                    'text-primary': r_event.run_action_id == 5 || r_event.run_action_id == 6 || r_event.run_action_id == 12,
                                                    'text-dark': r_event.run_action_id == 8 || r_event.run_action_id == 11 || r_event.run_action_id == 9 || r_event.run_action_id == 10 || r_event.run_action_id == 7,
                                                    'text-light': r_event.run_action_id == 7
                                                    }"><i class="fa fa-cube fa-lg ml-1" aria-hidden="true"></i>&nbsp;{{r_event.label | uppercase}}&nbsp;
                                                <span *ngIf="r_event.run_action_id == 5 || r_event.run_action_id == 6">TRIP</span>
                                                <span *ngIf="r_event.run_action_id == 12 || r_event.run_action_id == 13">JOB</span>
                                            </strong>
                                            <span class="event-date"><small>{{r_event.start | date :'d MMM y'}}</small>&nbsp;&nbsp;
                                                <i class="fa fa-md fa-trash text-danger" ngbTooltip="Delete Event"></i>
                                            </span>
                                        </div>
                                        <div class="row">
                                            <div class="col-1 d-flex align-items-center justify-content-center">
                                                <div class="timeline-line"></div>
                                            </div>
                                            <div class="col-11 pl-0 mb-3">
                                                <p class="event-details mb-0 text-justify"><i class="fa fa-map-marker ml-1 mr-1" aria-hidden="true" *ngIf="r_event.location_id"></i>
                                                    <small *ngIf="r_event.location_id">{{r_event.street_no}} {{r_event.street}} {{r_event.suburb}} {{r_event.abbreviation}} <span *ngIf="r_event.postal_code != 0">{{r_event.postal_code}}</span></small><br *ngIf="r_event.location_id"/>
                                                    <small>{{r_event.start | date:'EE, d MMM y'}} {{r_event.start | date:'hh:mm a'}} - {{r_event.end | date:'EE, d MMM y'}} {{r_event.end | date:'hh:mm a'}}</small><br/>
                                                    <small *ngIf="r_event.connote_site_id">{{r_event.control_no}} <span *ngIf="r_event.customer_name">- {{r_event.customer_name}}</span></small><br *ngIf="r_event.connote_site_id || r_event.customer_name"/>
                                                    <small *ngIf="r_event.personnel_print_name">{{r_event.personnel_print_name}}</small><br *ngIf="r_event.personnel_print_name"/>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- run event details -->
                    <div class="col-md-8 bg-white event-view-container"> 
                        <div class="clearfix">  
                            <ul class="nav nav-tabs custom top ">
                                <li class="nav-item">
                                    <a class="nav-link active" href="#eDetails" data-toggle="tab" id="tDetails">Details</a>
                                </li>
                                <li class="nav-item" *ngIf="run_event?.run_action_id < 5">
                                    <a class="nav-link" href="#eImages" data-toggle="tab" id="tImages">Images</a>
                                </li>
                            </ul>
                        </div>
                        <div class="tab-content top">
                            <div class="tab-pane active" id="eDetails">
                                <form [formGroup]="frm_run_event">
                                    <div class="row">
                                        <div class="form-group col-md-4">
                                            <label class="form-control-label"> Run Action<span class="text-danger">*</span></label>
                                            <select class="form-control form-control-sm" formControlName="run_action_id" placeholder="Select">
                                                <option selected value='' disabled>Select..</option>
                                                <option  *ngFor="let action of run_actions" value="{{action.id}}">{{action.label | uppercase}}</option>
                                            </select>
                                            <div *ngIf="frm_run_event.controls.run_action_id.touched" >
                                                <div *ngIf="frm_run_event.controls.run_action_id.errors?.required">
                                                    <small class="text-danger">Run Action is required.</small>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    
                                    <div class="row">
                                        <div class="form-group col-md-6" >
                                            <label class="form-control-label">Start Date<span class="text-danger">*</span></label>
                                            <input formControlName="start" class="form-control form-control-sm" type="datetime-local" step="1" required> 
                                            <div *ngIf="frm_run_event.controls.start.touched" >
                                                <div *ngIf="frm_run_event.controls.start.errors?.required">
                                                    <small class="text-danger">Start Date is required.</small>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="form-group col-md-6" >
                                            <label class="form-control-label">End Date<span class="text-danger">*</span></label>
                                            <input formControlName="end" class="form-control form-control-sm" type="datetime-local" step="1" required> 
                                            <div *ngIf="frm_run_event.controls.end.touched" >
                                                <div *ngIf="frm_run_event.controls.end.errors?.required">
                                                    <small class="text-danger" >End Date is required.</small>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
    
                                    <div class="row">

                                        <div class="form-group col-md-12" >
                                            <label class="form-control-label">Location<span class="text-danger">*</span> &nbsp;<button class="btn btn-sm btn-gray btn-rounded" (click)="openModal(location)"><i>Change</i></button></label>
                                            <div class="input-group d-flex align-items-center">
                                                <input type="hidden" formControlName="location_id">
                                                <input formControlName="location_description" class="form-control form-control-sm" type="text" disabled>
                                                <i (click)="clearLocation()" ngbTooltip="Clear" class="fa fa-eraser ml-2" aria-hidden="true"></i> 
                                            </div>
                                            <div *ngIf="frm_run_event.controls.location_id.touched" >
                                                <div *ngIf="frm_run_event.controls.location_id.errors?.required">
                                                    <small class="text-danger">Location is required.</small>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
    
                                    <div class="row">
                                        <div class="form-group col-md-3" >
                                            <label class="form-control-label">Odometer<span class="text-danger">*</span></label>
                                            <input formControlName="odometer" class="form-control form-control-sm" type="number" required> 
                                            <div *ngIf="frm_run_event.controls.odometer.touched" >
                                                <div *ngIf="frm_run_event.controls.odometer.errors?.required">
                                                    <small class="text-danger">Odometer is required.</small>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="form-group col-md-3" >
                                            <label class="form-control-label">Hubometer</label>
                                            <input formControlName="hubometer1" class="form-control form-control-sm" type="number"> 
                                        </div>
                                        <div class="form-group col-md-3" >
                                            <label class="form-control-label">Hubometer2</label>
                                            <input formControlName="hubometer2" class="form-control form-control-sm" type="number"> 
                                        </div>
                                        <div class="form-group col-md-3" >
                                            <label class="form-control-label">Hubometer3</label>
                                            <input formControlName="hubometer3" class="form-control form-control-sm" type="number"> 
                                        </div>
                                    </div>
    
                                    <div class="row">
                                        <div class="form-group col-md-3" >
                                            <label class="form-control-label">Hubometer4</label>
                                            <input formControlName="hubometer4" class="form-control form-control-sm" type="number" > 
                                        </div>
                                        <div class="form-group col-md-3" >
                                            <label class="form-control-label">Hubometer5</label>
                                            <input formControlName="hubometer5" class="form-control form-control-sm" type="number"> 
                                        </div>
                                        <div class="form-group col-md-3" >
                                            <label class="form-control-label">Hubometer6</label>
                                            <input formControlName="hubometer6" class="form-control form-control-sm" type="number"> 
                                        </div>
                                        <div class="form-group col-md-3" >
                                            <label class="form-control-label">Hubometer7</label>
                                            <input formControlName="hubometer7" class="form-control form-control-sm" type="number"> 
                                        </div>
                                    </div>
    
                                    <div class="row">
                                        <div class="form-group col-md-3" >
                                            <label class="form-control-label">Axle 1</label>
                                            <input formControlName="axle1" class="form-control form-control-sm" type="number"> 
                                        </div>
                                        <div class="form-group col-md-3" >
                                            <label class="form-control-label">Axle 2</label>
                                            <input formControlName="axle2" class="form-control form-control-sm" type="number"> 
                                        </div>
                                        <div class="form-group col-md-3" >
                                            <label class="form-control-label">Axle 3</label>
                                            <input formControlName="axle3" class="form-control form-control-sm" type="number"> 
                                        </div>
                                        <div class="form-group col-md-3" >
                                            <label class="form-control-label">Axle 4</label>
                                            <input formControlName="axle4" class="form-control form-control-sm" type="number"> 
                                        </div>
                                    </div>
    
                                    <div class="row">
                                        <div class="form-group col-md-3" >
                                            <label class="form-control-label">Axle 5</label>
                                            <input formControlName="axle5" class="form-control form-control-sm" type="number"> 
                                        </div>
                                        <div class="form-group col-md-3" >
                                            <label class="form-control-label">Axle 6</label>
                                            <input formControlName="axle6" class="form-control form-control-sm" type="number"> 
                                        </div>
                                        <div class="form-group col-md-3" >
                                            <label class="form-control-label">Axle 7</label>
                                            <input formControlName="axle7" class="form-control form-control-sm" type="number"> 
                                        </div>
                                        <div class="form-group col-md-3" >
                                            <label class="form-control-label">Gross Weight</label>
                                            <input formControlName="gross_weight" class="form-control form-control-sm" type="number"> 
                                        </div>
                                    </div>
    
                                    <div class="row">
                                        <div class="form-group col-md-6" >
                                            <label class="form-control-label">Personnel Name</label>
                                            <input formControlName="personnel_print_name" class="form-control form-control-sm" type="text"> 
                                        </div>
                                        <div class="form-group col-md-6" >
                                            <label class="form-control-label">Notes<span class="text-danger">*</span></label>
                                            <textarea formControlName="notes" class="form-control form-control-sm"></textarea> 
                                            <div *ngIf="frm_run_event.controls.notes.touched" >
                                                <div *ngIf="frm_run_event.controls.notes.errors?.required">
                                                    <small class="text-danger">Notes is required.</small>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
    
                                    
                                    <small class="mr-auto"><i> Note: <span class="text-danger">*</span> = required</i></small>
                                    <br/>
                                    <div class="text-right">
                                        <button [disabled]="!frm_run_event.valid && !frm_run_event.pristine" class="btn btn-sm btn-success" (click)="onSubmitRunEvent(frm_run_event.value)">Save</button>
                                    </div>
                                    
                                </form>
                            </div>                  
                            <div class="tab-pane" id="eImages" *ngIf="run_event?.run_action_id < 5">
                                <div class="col-12">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="row">
                                                <div class="col-12">
                                                    <button class="btn btn-sm btn-gray btn-rounded"><i>Add Docket Image</i></button>
                                                </div>
                                            </div>
                                            <br/>
                                            <div class="row" *ngIf="run_event?.run_event_files.length > 0">
                                                <div class="col-4" *ngFor="let eimg of run_event.run_event_files">
                                                    <div class="card">
                                                        <div class="card-header h-50 text-right" *ngIf="eimg.file_type_id == 1 || eimg.file_type_id == 2">
                                                            <i class="fa fa-remove text-danger"></i>
                                                        </div>
                                                        <img *ngIf="eimg.file_type_id == 1 || eimg.file_type_id == 1" class="card-img-top w-100" src="{{fileStoragePath}}/{{eimg.folder_path}}/{{eimg.filename}}">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
</div>

<!--  modal for location -->
<ng-template #location let-close="close">
    <div class="modal-header">
        <div class="col px-0">
            <div class="row no-gutters pt-0">
                <div class="col ml-1"><h5 class="modal-title">&nbsp;Change Location</h5></div>
            </div>
        </div>
       
        <button type="button" class="close" (click)="close();">
            <span aria-hidden="true">&times;</span>                                                                                           
        </button>
    </div>
    <div class="modal-body">
        <div class="row pt-0">
            <div class="col-md-12">
                <div class="form-group col-md-12">
                    <div><i>Current location: {{this.run_event.location_description}}</i> <br/></div>
                    <h6>Location:</h6>
                    <select [disabled]="!is_select_location" class="form-control form-control-sm" [(ngModel)]="loc">
                        <option disabled value="null">Select Location Address</option>
                        <option *ngFor="let l of locations" [ngValue]="l">
                            <span *ngIf="l.street_no">{{l.street_no}}&nbsp;</span>
                            <span *ngIf="l.street">{{l.street}}&nbsp;</span>
                            <span *ngIf="l.suburb">{{l.suburb}}&nbsp;</span>
                            <span *ngIf="l.abbreviation">{{l.abbreviation}}&nbsp;</span>
                            <span *ngIf="l.postal_code">{{l.postal_code}}&nbsp;</span>
                        </option>
                    </select>
                    <br/>
                    <button class="btn btn-sm btn-gray btn-rounded" (click)="enableCreate()" *ngIf="is_select_location"><i>Add new Address</i></button>
                    <button class="btn btn-sm btn-gray btn-rounded" (click)="enableSelect()" *ngIf="!is_select_location"><i>Select Address</i></button>
                    
                    <div *ngIf ="!is_select_location">
                        <br/>
                        <div>
                            <form [formGroup]="frm_new_location">
                                <div class="form-group form-group-sm">
                                    <label >Search Address: <span class="text-danger">*</span></label>
                                    <div>
                                        <ngx-geo-autocomplete id="new_loc" (componentCallback)="locationSiteCallback($event)" [userSettings]="userSettings"></ngx-geo-autocomplete>
                                    </div>
                                </div>
                                <div class="row mt-3 pt-3">
                                        <div class="form-group col-md-4" >
                                            <label for="input-1">Street Number:</label>
                                            <input formControlName="street_no" type="text" class="form-control form-control-sm">
                                        </div>
                                        <div class="form-group col-md-8" >
                                            <label for="input-1">Street: <span class="text-danger">*</span></label>
                                            <input formControlName="street" type="text" class="form-control form-control-sm" >
                                        </div>
                                </div>
                                <div class="row">
                                    <div class="form-group col-md-4" >
                                        <label for="input-1">Suburb/City: <span class="text-danger">*</span></label>
                                        <input formControlName="suburb" type="text" class="form-control form-control-sm" >
                                    </div>
                                    <div class="form-group col-md-4" >
                                        <label for="input-1">State: <span class="text-danger">*</span></label>
                                        <input formControlName="state" type="text" class="form-control form-control-sm" >
                                    </div>
                                    <div class="form-group col-md-4" >
                                        <label for="input-1">Postal Code:</label>
                                        <input formControlName="postal_code" type="text" class="form-control form-control-sm" >
                                    </div> 
                                </div>
                                <div class="row">
                                    <div class="form-group col-md-4" >
                                        <label for="input-1">Latitude: <span class="text-danger">*</span></label>
                                        <input formControlName="lat" type="text" class="form-control form-control-sm" >
                                    </div>
                                    <div class="form-group col-md-4" >
                                        <label for="input-1">Longtitude: <span class="text-danger">*</span></label>
                                        <input formControlName="long" type="text" class="form-control form-control-sm" >
                                    </div> 
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="footer text-right">
            <button type="button" class="btn btn-sm btn-success" (click)="updateLocation(frm_new_location.value)" [disabled]="(is_select_location && !loc) || (!is_select_location && no_coordinates)">Select</button>&nbsp;&nbsp;&nbsp;
            <button type="button" class="btn btn-sm btn-gray" (click)="close()">Cancel</button>
        </div>
        
    </div>

</ng-template>